import { EmptyCell } from '../../formatters/genericFormatters';
import { AssetDeviceType, RegisteredAssetModel } from '@casops/store/apis/registeredAssetsApi';

interface GeofenceCountCellRendererProps {
  value?: number;
  data: RegisteredAssetModel;
}

export default function GeofenceCountCellRenderer({
  value,
  data,
}: GeofenceCountCellRendererProps): string {
  if (typeof value !== 'number' || !data || data.hw === AssetDeviceType.PPU) {
    return EmptyCell;
  }

  return value.toString();
}
